// Direct `sonner` toast imports are restricted by oxlint; this wrapper is the single approved usage (see override in .oxlintrc.json).
import { toast as sonnerToast, type ToasterProps } from 'sonner';
import { Toast } from './Toast';
import type { ToastVariant } from './toast.types';

const DEFAULT_TOAST_DURATION = 5000;

interface ToastOptions {
  title: string;
  description?: string;
  duration?: number;
  position?: ToasterProps['position'];
}

interface CreateToastProps extends ToastOptions {
  variant: ToastVariant;
}

export const useToast = () => {
  const createToast = (props: CreateToastProps) => {
    const duration = props.duration ?? DEFAULT_TOAST_DURATION;
    const position = props.position ?? 'top-center';

    sonnerToast.custom((id) => <Toast id={id} {...props} duration={duration} />, {
      duration,
      position,
    });
  };

  return {
    default: (props: ToastOptions) => createToast({ variant: 'default', ...props }),
    success: (props: ToastOptions) => createToast({ variant: 'success', ...props }),
    error: (props: ToastOptions) => createToast({ variant: 'destructive', ...props }),
  };
};
